import {LocalizableString} from "@dp-instant/i18n";

export const translations: Record<string, LocalizableString> = {
    // Win / Lose
    "ui-win-win_label": {default: "YOU WON", localizations: {ru_RU: "ПОБЕДА"}},
    "ui-lose-lose_label": {default: "YOU LOSE", localizations: {ru_RU: "ПОРАЖЕНИЕ"}},
    "ui-win-reward_label": {default: "YOUR REWARD", localizations: {ru_RU: "НАГРАДА"}},
    "ui-win-claim": {default: "CLAIM", localizations: {ru_RU: "ЗАБРАТЬ"}},
    "ui-win-continue": {default: "CONTINUE", localizations: {ru_RU: "ПРОДОЛЖИТЬ"}},
    "ui-try-again-button": {default: "TRY AGAIN", localizations: {ru_RU: "ЕЩЁ РАЗ"}},
    "ui-lose-upgrade": {default: "UPGRADE", localizations: {ru_RU: "ПРОКАЧАТЬСЯ"}},
    "ui-lose-try-again": {default: "TRY AGAIN", localizations: {ru_RU: "ЕЩЁ РАЗ"}},

    // Menu / HUD
    "ui-menu-tap_to_play": {default: "TAP TO PLAY", localizations: {ru_RU: "НАЖМИ ЧТОБЫ ИГРАТЬ"}},
    "tap_to_play_go": {default: "GO!", localizations: {ru_RU: "ВПЕРЁД!"}},
    "ui-menu-lvl": {default: "LVL", localizations: {ru_RU: "УР"}},
    "ui-menu-level_num": {default: "LEVEL", localizations: {ru_RU: "УРОВЕНЬ"}},
    "ui-menu-capturing": {default: "CAPTURING", localizations: {ru_RU: "ЗАХВАТ"}},

    // Shop
    "ui-store-building": {default: "BUILDING", localizations: {ru_RU: "ЗДАНИЕ"}},
    "ui-store-fighter": {default: "FIGHTER", localizations: {ru_RU: "БОЕЦ"}},
    "ui-store-coins": {default: "COINS", localizations: {ru_RU: "МОНЕТЫ"}},
    "ui-store-color": {default: "COLOR", localizations: {ru_RU: "ЦВЕТ"}},
    "ui-fillbox-get": {default: "GET", localizations: {ru_RU: "ПОЛУЧИТЬ"}},

    // Popups
    "ui-fillbox-title": {default: "GIFT", localizations: {ru_RU: "ПОДАРОК"}},
    "ui-offline-title": {default: "OFFLINE EARNINGS", localizations: {ru_RU: "ОФЛАЙН ЗАРАБОТОК"}},
    "ui-offline-description": {default: "YOU WERE AWAY FOR:", localizations: {ru_RU: "ВЫ ОТСУТСТВОВАЛИ:"}},
    "ui-offline-mult_button": {default: "MULTIPLY", localizations: {ru_RU: "УМНОЖИТЬ"}},
    "ui-exit-exit_label": {default: "EXIT", localizations: {ru_RU: "ВЫХОД"}},
    "ui-exit-description": {default: "Leave the game?", localizations: {ru_RU: "Выйти из игры?"}},
    "ui-battle-battle_title": {default: "Battle Results", localizations: {ru_RU: "Результаты боя"}},
    "ui-common-free": {default: "FREE", localizations: {ru_RU: "БЕСПЛАТНО"}},
    "level_completed_message": {default: "ALL STAGES COMPLETED!", localizations: {ru_RU: "ВСЕ ЭТАПЫ ПРОЙДЕНЫ!"}},

    // Social / Leaderboard
    "game_login_btn": {default: "Login", localizations: {ru_RU: "Войти"}},
    "game_login_text": {default: "Log in to compete with others.", localizations: {ru_RU: "Войдите, чтобы соревноваться."}},
    "game_invite": {default: "Invite Friend", localizations: {ru_RU: "Пригласить друга"}},
    "game_pending": {default: "Pending...", localizations: {ru_RU: "Ожидание..."}},

    // Settings
    "ui-settings-title": {default: "SETTINGS", localizations: {ru_RU: "НАСТРОЙКИ"}},
    "ui-settings-language": {default: "LANGUAGE", localizations: {ru_RU: "ЯЗЫК"}},
    "ui-settings-sound": {default: "SOUND", localizations: {ru_RU: "ЗВУК"}},
    "ui-settings-vibration": {default: "VIBRATION", localizations: {ru_RU: "ВИБРАЦИЯ"}},
    "ui-settings-vibration-buttons": {default: "Buttons", localizations: {ru_RU: "Кнопки"}},
    "ui-settings-vibration-battle": {default: "Battle", localizations: {ru_RU: "В бою"}},
    "ui-settings-fullscreen": {default: "FULLSCREEN", localizations: {ru_RU: "ПОЛНЫЙ ЭКРАН"}},

    // Rewarded Progress
    "ui-shop-daily-rewards": {default: "DAILY REWARDS", localizations: {ru_RU: "ЕЖЕДНЕВНЫЕ НАГРАДЫ"}},
    "ui-shop-watch-ad": {default: "WATCH", localizations: {ru_RU: "СМОТРЕТЬ"}},
    "ui-shop-claim": {default: "CLAIM", localizations: {ru_RU: "ПОЛУЧИТЬ"}},

    // Payment
    "ui-store-topup-stars": {default: "TOP UP", localizations: {ru_RU: "ПОПОЛНИТЬ"}},
    "ui-payment-title": {default: "PAYMENT", localizations: {ru_RU: "ОПЛАТА"}},
    "ui-payment-topup-title": {default: "TOP UP", localizations: {ru_RU: "ПОПОЛНЕНИЕ"}},
    "ui-payment-tg-stars": {default: "Telegram Stars", localizations: {ru_RU: "Telegram Stars"}},
    "ui-payment-balance": {default: "Balance", localizations: {ru_RU: "Баланс"}},
    "ui-payment-success": {default: "Success!", localizations: {ru_RU: "Готово!"}},
    "ui-payment-error": {default: "Payment error. Please try again.", localizations: {ru_RU: "Ошибка оплаты. Попробуйте ещё раз."}},
    "ui-common-cancel": {default: "CANCEL", localizations: {ru_RU: "ОТМЕНА"}},

    // Insufficient coins
    "ui-insufficient-title": {default: "Not enough coins", localizations: {ru_RU: "Не хватает монет"}},
    "ui-insufficient-need": {default: "Need", localizations: {ru_RU: "Нужно"}},
    "ui-insufficient-buy": {default: "Buy", localizations: {ru_RU: "Купить"}},

    // NoAds
    "ui-noads-title": {default: "NO ADS", localizations: {ru_RU: "БЕЗ РЕКЛАМЫ"}},
    "ui-noads-description": {default: "Get all ad bonuses instantly, no more ads!", localizations: {ru_RU: "Получай все бонусы за рекламу без просмотра!"}},
    "ui-noads-3days": {default: "3 days", localizations: {ru_RU: "3 дня"}},
    "ui-noads-forever": {default: "Forever", localizations: {ru_RU: "Навсегда"}},
    "ui-noads-best": {default: "Best value", localizations: {ru_RU: "Лучшее предложение"}},
    "ui-noads-cancel": {default: "CANCEL", localizations: {ru_RU: "ОТМЕНА"}},

    // Referral
    "ui-ref-claim": {default: "Claim", localizations: {ru_RU: "Забрать"}},
    "ui-ref-copy": {default: "Copy link", localizations: {ru_RU: "Копировать"}},
    "ui-ref-copied": {default: "Copied!", localizations: {ru_RU: "Скопировано!"}},
    "ui-ref-share": {default: "Share", localizations: {ru_RU: "Поделиться"}},
    "ui-ref-commission": {default: "Invite friends and earn 25% of their purchases", localizations: {ru_RU: "Приглашай друзей и получай 25% от их покупок"}},
    "ui-ref-friend-bonus": {default: "Your friend gets 25 ⭐ on signup", localizations: {ru_RU: "Твой друг получит 25 ⭐ за регистрацию"}},
    "ui-ref-referrer-reward": {default: "You get 10 ⭐ when friend reaches LVL 10", localizations: {ru_RU: "Ты получишь 10 ⭐ когда друг достигнет 10 уровня"}},
    "ui-ref-friends": {default: "Friends", localizations: {ru_RU: "Друзья"}},
    "ui-ref-empty": {default: "Invite friends and earn ⭐", localizations: {ru_RU: "Пригласи друзей и зарабатывай ⭐"}},
    "ui-ref-loading": {default: "Loading...", localizations: {ru_RU: "Загрузка..."}},
    "ui-ref-error": {default: "Failed to load", localizations: {ru_RU: "Не удалось загрузить"}},

    // Transaction History
    "ui-tx-history-title": {default: "Transaction History", localizations: {ru_RU: "История транзакций"}},
    "ui-tx-filter-all": {default: "All", localizations: {ru_RU: "Все"}},
    "ui-tx-filter-purchases": {default: "Purchases", localizations: {ru_RU: "Покупки"}},
    "ui-tx-filter-topups": {default: "Top-ups", localizations: {ru_RU: "Пополнения"}},
    "ui-tx-empty": {default: "No transactions yet", localizations: {ru_RU: "Транзакций пока нет"}},
    "ui-tx-load-more": {default: "Load more", localizations: {ru_RU: "Загрузить ещё"}},

    // Tribute payment flow
    "ui-tribute-waiting": {default: "Waiting for payment...", localizations: {ru_RU: "Ожидание оплаты..."}},
    "ui-tribute-timeout": {default: "Payment not received. Please try again.", localizations: {ru_RU: "Оплата не получена. Попробуйте снова."}},
    "ui-tribute-error": {default: "Payment error. Please try again.", localizations: {ru_RU: "Ошибка оплаты. Попробуйте снова."}},
    "ui-tribute-received": {default: "Payment received", localizations: {ru_RU: "Оплата получена"}},
    "ui-tribute-confirmed": {default: "Your payment has been confirmed!", localizations: {ru_RU: "Ваш платёж подтверждён!"}},

    // TON payment flow
    "ui-ton-connecting": {default: "Connecting wallet...", localizations: {ru_RU: "Подключение кошелька..."}},
    "ui-ton-waiting": {default: "Waiting for confirmation...", localizations: {ru_RU: "Ожидание подтверждения..."}},
    "ui-ton-timeout": {default: "Payment timeout. Please try again.", localizations: {ru_RU: "Таймаут оплаты. Попробуйте снова."}},
    "ui-ton-error": {default: "TON payment error. Please try again.", localizations: {ru_RU: "Ошибка TON оплаты. Попробуйте снова."}},
    "ui-ton-checking": {default: "Checking payment", localizations: {ru_RU: "Проверяем оплату"}},
    "ui-ton-checking-msg": {default: "If you sent the payment, it will be confirmed shortly.", localizations: {ru_RU: "Если вы отправили оплату, она будет подтверждена в ближайшее время."}},

    // Wallet popup
    "ui-wallet-title": {default: "TON Wallet", localizations: {ru_RU: "TON Кошелёк"}},
    "ui-wallet-not-connected": {default: "No wallet connected", localizations: {ru_RU: "Кошелёк не подключён"}},
    "ui-wallet-connect": {default: "Connect Wallet", localizations: {ru_RU: "Подключить кошелёк"}},
    "ui-wallet-disconnect": {default: "Disconnect Wallet", localizations: {ru_RU: "Отключить кошелёк"}},
    "ui-common-back": {default: "BACK", localizations: {ru_RU: "НАЗАД"}},

    // Daily Leaderboard
    "ui-daily-lb-title": {default: "Daily Rating", localizations: {ru_RU: "Рейтинг дня"}},
    "ui-daily-lb-top": {default: "Top", localizations: {ru_RU: "Топ"}},
    "ui-daily-lb-win": {default: "win", localizations: {ru_RU: "получат"}},
    "ui-daily-lb-everyday": {default: "every day", localizations: {ru_RU: "каждый день"}},
    "ui-daily-lb-info": {default: "Win = points. Streak bonus. Premium = x2. Rewards given automatically", localizations: {ru_RU: "Победа = очки. Бонус за серию. Премиум = x2. Награды начисляются автоматически"}},
    "ui-daily-lb-pts": {default: "pts", localizations: {ru_RU: "очк"}},
    "ui-daily-lb-empty": {default: "No entries yet. Play to compete!", localizations: {ru_RU: "Пока пусто. Играй чтобы попасть в рейтинг!"}},
    "ui-loading": {default: "Loading...", localizations: {ru_RU: "Загрузка..."}},
    "ui-error": {default: "Error", localizations: {ru_RU: "Ошибка"}},
    "ui-noads-rating-boost": {default: "x2 points in daily rating", localizations: {ru_RU: "x2 очков в рейтинге дня"}},
    "ui-daily-lb-place-1": {default: "1st Place!", localizations: {ru_RU: "1 место!"}},
    "ui-daily-lb-place-2": {default: "2nd Place!", localizations: {ru_RU: "2 место!"}},
    "ui-daily-lb-place-3": {default: "3rd Place!", localizations: {ru_RU: "3 место!"}},
};
